module.exports = __webpack_public_path__ + "img/J11971.0bcea16c.png";